import React from 'react';

import Icon, { IconProps } from './icon';

const svg: React.FC<IconProps> = (props) => (
  <svg
    aria-hidden="true"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    {...props}
  >
    <path d="M14.7957 4.92453L9.86524 0.196167C9.69643 0.0342403 9.45642 -0.0332027 9.22407 0.0155461C8.9909 0.06407 8.80197 0.221272 8.71867 0.436222C8.43732 1.1628 8.36862 1.97637 8.5194 2.7534L5.9489 4.67082C3.34743 3.7838 1.29934 5.1548 1.21037 5.2157C1.04349 5.33025 0.938166 5.50846 0.921465 5.70375C0.9042 5.90018 0.97774 6.09284 1.12318 6.23231L4.50671 9.47716L0.126645 13.2921C-0.0422032 13.4541 -0.0422266 13.7166 0.126645 13.8786C0.211069 13.9595 0.321695 14 0.432368 14C0.543017 14 0.65369 13.9595 0.738091 13.8786L5.11837 10.0634L8.50179 13.3081C8.63329 13.4343 8.81021 13.5041 8.99395 13.5041C9.01333 13.5041 9.0328 13.5033 9.05227 13.5017C9.25675 13.4856 9.44251 13.3846 9.56299 13.2232C9.63536 13.1255 10.0084 12.5958 10.2463 11.7694C10.5411 10.745 10.5001 9.6825 10.1297 8.68044L12.1291 6.21529C12.9396 6.36034 13.7882 6.29425 14.5457 6.02385C14.7694 5.94408 14.9332 5.76292 14.9837 5.53998C15.0347 5.31637 14.9644 5.08626 14.7957 4.92453Z" />
  </svg>
);

const IconPin: React.FC<IconProps> = (props) => <Icon {...props} svg={svg} />;

export default IconPin;
